import React from 'react';
import Head from 'next/head';

import Raffle from '../../components/Raffle';
import Auction from '../../components/Auction';
import useRaffles from '../../hooks/useRaffles';
import { fetchRaffles } from '../../util/api';
import { Spinner } from 'react-bootstrap';

const ShopItem = ({ raffleKey, type }) => {
  switch (type) {
    case 'raffle':
      return <Raffle raffleKey={raffleKey} />;
    case 'auction':
      return <Auction raffleKey={raffleKey} />;
    default:
      return <Raffle raffleKey={raffleKey} />;
  }
};

const Shop = ({ raffleKey, metadata }) => {
  const raffle = useRaffles(raffleKey);

  const title = `${metadata.title} - Rainbow Shop | Noundles`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta
          name="description"
          content={metadata.description}
          key="description"
        />
        <meta
          property="og:title"
          content={`${metadata.title} - Rainbow Shop | Noundles`}
          key="og:title"
        />
        <meta
          property="twitter:title"
          content={`${metadata.title} - Rainbow Shop | Noundles`}
          key="twitter:title"
        />
        <meta
          property="og:description"
          content={metadata.description}
          key="og:description"
        />
        <meta property="og:image" content={metadata.image} key="og:image" />
        <meta
          property="twitter:description"
          content={metadata.description}
          key="twitter:description"
        />
        <meta
          property="twitter:image"
          content={metadata.image}
          key="twitter:image"
        />
      </Head>
      <div className="blue-gradient">
        <div className="container py-5">
          {raffle ? (
            <ShopItem raffleKey={raffleKey} type={raffle.type} />
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

Shop.getInitialProps = async ({ query }) => {
  const { raffleKey } = query;

  const raffle = await fetchRaffles().then((raffles) => raffles[raffleKey]);
  return {
    raffleKey,
    metadata: {
      title: raffle.title,
      description: raffle.description,
      image: raffle.image,
    },
  };
};

export default Shop;
